import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VForm,{ref:_vm.reference,staticClass:"my-2",model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('div',{staticClass:"form-container"},[_c('div',{staticClass:"form-tab"},[_vm._v(_vm._s(_vm.formTitle))]),_c(VRow,{staticClass:"pt-6",class:{ 'boxed': _vm.boxed }},[_vm._t("fields")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }